import React from "react";

const ProductSkeleton = () => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      {/* Image skeleton */}
      <div className="w-full h-48 bg-gray-200 animate-pulse"></div>
      
      {/* Content skeleton */}
      <div className="p-4">
        {/* Title skeleton */}
        <div className="h-4 bg-gray-200 rounded animate-pulse mb-2 w-3/4"></div>
        
        {/* Price skeleton */}
        <div className="h-6 bg-gray-200 rounded animate-pulse mb-3 w-1/3"></div>
        
        {/* Description skeleton */}
        <div className="h-3 bg-gray-200 rounded animate-pulse mb-1 w-full"></div>
        <div className="h-3 bg-gray-200 rounded animate-pulse mb-3 w-5/6"></div>
        
        {/* Button skeleton */}
        <div className="h-8 bg-gray-200 rounded animate-pulse w-full mt-4"></div>
      </div>
    </div>
  );
};

const ProductLoadingSkeleton = () => {
  // Create an array of skeleton placeholders
  const skeletonItems = Array(8).fill(0);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {skeletonItems.map((_, index) => (
        <ProductSkeleton key={`skeleton-${index}`} />
      ))}
    </div>
  );
};

export default ProductLoadingSkeleton;